import type { ReactNode } from 'react'
import { Text } from './Text'

export interface ActionRowProps {
	headers: string[]
	values: ReactNode[]
	className?: string
	onClick?: () => void
}

export const ActionRow = ({ headers, values, className, onClick }: ActionRowProps) => {
	return (
		// biome-ignore lint/a11y/noStaticElementInteractions: role is conditionally applied when onClick is provided
		<div
			role={onClick ? 'button' : undefined}
			tabIndex={onClick ? 0 : undefined}
			className={`
        flex flex-row justify-between gap-8 w-full p-6 border border-neutral-200 rounded-lg
        bg-neutral-0 ${className || ''}
      `}
			onClick={onClick}
			onKeyDown={
				onClick
					? (e) => {
							if (e.key === 'Enter' || e.key === ' ') onClick()
						}
					: undefined
			}>
			{headers.map((header, index) => (
				<div key={header} className='flex flex-col gap-1 flex-grow basis-0'>
					<Text variant='xsmall' weight='regular' className='text-neutral-500 whitespace-nowrap'>
						{header}
					</Text>
					<Text variant='small' weight='semibold' className='text-neutral-800 whitespace-nowrap'>
						{values[index]}
					</Text>
				</div>
			))}
		</div>
	)
}
